// removed by extract-text-webpack-plugin
module.exports = {"paymentMethodWrap":"qempo_PurchaseSummary_paymentMethodWrap-3QVfFQ8","title":"qempo_PurchaseSummary_title-2iQqtSK","dataWrap":"qempo_PurchaseSummary_dataWrap-2wyr-KR","paymentMethod":"qempo_PurchaseSummary_paymentMethod-zOJvLGn","lastDigits":"qempo_PurchaseSummary_lastDigits-E3-N0En","cancel":"qempo_PurchaseSummary_cancel-3TnQxBg"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/order/Purchase/components/PurchaseSummary/PurchaseSummary.scss
// module id = 1848
// module chunks = 0